/* Nostalgia theme — lean vanilla JS */
(function () {
  "use strict";
  var body = document.body;

  // Mobile drawer
  // aria-expanded mirrors the menu state for screen readers (no visual change).
  function menuState(open){ document.querySelectorAll('[data-menu-open]').forEach(function (b){ b.setAttribute('aria-expanded', open ? 'true' : 'false'); }); }
  function setDrawer(open){ body.classList.toggle('drawer-open', open); menuState(open); }
  var deskMq = window.matchMedia('(min-width:1000px)');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) {
      if (deskMq.matches && header) { menuState(header.classList.toggle('navopen')); }
      else { setDrawer(true); }
    }
    if (e.target.closest('[data-menu-close]') || e.target.classList.contains('drawer-scrim')) { setDrawer(false); }
  });

  var header = document.querySelector('header.site-header');

  /* Header cart — phone-only visibility.
     The cart link is hidden on a phone until the basket has something in it
     (base.css keys off .has-cart on the header). Liquid sets that class when
     the page is rendered, which is right for a fresh render and wrong for two
     common cases: a page served from cache or the back/forward cache, and an
     AJAX add that never reloads anything. So reconcile from /cart.js on load,
     and again whenever something posts to /cart/add|change|update — the same
     net snippets/quantity-discount.liquid already casts over those endpoints. */
  (function () {
    if (!header) return;
    var pip = header.querySelector('[data-cart-count]');
    function paint(n) {
      n = Number(n) || 0;
      header.classList.toggle('has-cart', n > 0);
      if (!pip) return;
      pip.textContent = n;
      pip.hidden = n === 0;
      var link = header.querySelector('.cart');
      if (link) link.setAttribute('aria-label', 'Cart (' + n + ')');
    }
    /* One place that owns the header cart, so the cart page and the wishlist
       page (which both used to poke .cart-count directly) can't leave the
       phone header showing a basket that is empty, or hide one that isn't. */
    window.NLCart = { set: paint, refresh: function () { refresh(); } };
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) paint(c.item_count); })
        .catch(function () {});
    }
    refresh();
    // bfcache: a back-swipe restores the old DOM without re-running the page
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    function watch(url) {
      if (!url) return;
      url = String(url);
      if (url.indexOf('/cart/add') === -1 && url.indexOf('/cart/change') === -1 && url.indexOf('/cart/update') === -1) return;
      setTimeout(refresh, 250);
    }
    var of = window.fetch;
    if (of) {
      window.fetch = function (input) {
        watch(typeof input === 'string' ? input : (input && input.url));
        return of.apply(this, arguments);
      };
    }
    var ox = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
    if (ox) {
      window.XMLHttpRequest.prototype.open = function (m, u) { watch(u); return ox.apply(this, arguments); };
    }
  })();

  // Sticky header condenses in place after a small scroll. overflow-anchor:none
  // (CSS) stops the announcement's collapse from nudging scrollY, so no bounce.
  var condensed = false;
  function applyCondense() {
    if (!header) return;
    var y = window.scrollY;
    if (!condensed && y > 90) { condensed = true; header.classList.add('condensed'); }
    else if (condensed && y < 40) { condensed = false; header.classList.remove('condensed', 'navopen'); setTimeout(setHeaderVar, 420); }
  }

  // Publish the header's resting height so the hero can fill exactly the rest
  // of the screen. Only measure when it is NOT condensed — measuring the
  // shrunken header would make the hero grow as you scroll. Measured here,
  // before the first applyCondense(), so a mid-page reload still gets a real
  // number; re-measured 420ms after it un-condenses (the announcement's
  // collapse is animated) and on resize.
  function setHeaderVar() {
    if (!header || header.classList.contains('condensed')) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--hdr-h', h + 'px');
  }
  setHeaderVar();
  window.addEventListener('resize', setHeaderVar, { passive: true });
  window.addEventListener('load', setHeaderVar);

  window.addEventListener('scroll', applyCondense, { passive: true });
  applyCondense();

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setDrawer(false); }
  });

  // Collection cards: (1) the resting image stays the featured image; the HOVER
  // image is picked at random from the collection's allowed positions
  // (custom.card_image_positions), re-rolled between hovers;
  // (2) hovering a colour swatch swaps the shown image to that colour's photo.
  //
  // Cards injected by JS (Most loved on the homepage, the most-loved collection
  // sort) can't carry the hover image in their markup, so they're marked
  // data-hover-fetch: the product's second image is pulled from
  // /products/<handle>.js the first time the card is approached and dropped in
  // as a .pc-secondary, so those cards hover exactly like a Liquid-rendered one.
  // Waiting for that lookup on hover feels sluggish, so it runs as soon as the
  // card scrolls into view: by the time the cursor arrives the hover image is
  // already downloaded and the swap is instant. Skipped on metered/slow
  // connections, where hover-time loading is the kinder trade.
  var remoteHover = {};                        // handle -> url ('' = no 2nd image)
  var RHK = 'nostalgia:hoverimg:v1';
  try { remoteHover = JSON.parse(sessionStorage.getItem(RHK)) || {}; } catch (e) {}
  var conn = navigator.connection || {};
  // A touch screen synthesises mouseenter/:hover on the first tap, so the whole
  // hover layer below (second-image swap, its prefetch, swatch preview) turned
  // "tap the photo" into "swap the image and swallow the tap". Bind it only
  // where there is a real pointer.
  var canHover = !window.matchMedia || matchMedia('(hover:hover) and (pointer:fine)').matches;
  var mayPrefetch = !conn.saveData && !/(^|-)2g$/.test(conn.effectiveType || '') && 'IntersectionObserver' in window;
  var whenIdle = window.requestIdleCallback
    ? function (fn) { window.requestIdleCallback(fn, { timeout: 1200 }); }   // never starved
    : function (fn) { setTimeout(fn, 250); };
  function sized(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function addSecondary(card, url) {
    var im = card.querySelector('.im');
    if (!im || !url) return;
    var img = document.createElement('img');
    img.className = 'pc-secondary';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.setAttribute('decoding', 'async');
    img.setAttribute('sizes', '(max-width:900px) 45vw, 22vw');
    img.setAttribute('fetchpriority', 'low');   // never ahead of the resting image
    // .pc-ready gates the CSS fade, so a half-downloaded image never shows
    img.addEventListener('load', function () { img.classList.add('pc-ready'); });
    img.setAttribute('srcset', sized(url, 300) + ' 300w, ' + sized(url, 450) + ' 450w, ' + sized(url, 600) + ' 600w, ' + sized(url, 900) + ' 900w');
    img.setAttribute('src', sized(url, 600));
    im.appendChild(img);
  }

  function initCard(card) {
    if (card.getAttribute('data-pc-init')) return;    // bind() is safe to re-run
    card.setAttribute('data-pc-init', '1');
    var primary = card.querySelector('.pc-primary');
    if (!primary) return;
    // Mobile gets a plain link: no swap, and the hover images are never
    // downloaded there either.
    if (!canHover) return;
    var secondary = card.querySelector('.pc-secondary');
    var shuffle = (card.getAttribute('data-shuffle') || '').split('|').filter(Boolean);

    if (!secondary && card.hasAttribute('data-hover-fetch')) {
      var handle = (card.getAttribute('href') || '').split('/products/')[1] || '';
      handle = handle.split('?')[0].split('#')[0];
      var pulled = false;
      var pull = function () {
        if (pulled || !handle) return;
        pulled = true;
        if (typeof remoteHover[handle] === 'string') { addSecondary(card, remoteHover[handle]); return; }
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            var imgs = (d && d.images) || [];
            var restingUrl = (primary.getAttribute('src') || '').split('?')[0];
            var pick = '';
            for (var i = 0; i < imgs.length; i++) {
              var u = String(imgs[i]);
              if (u.indexOf('//') === 0) u = 'https:' + u;
              if (u.split('?')[0] !== restingUrl) { pick = u; break; }
            }
            remoteHover[handle] = pick;
            try { sessionStorage.setItem(RHK, JSON.stringify(remoteHover)); } catch (e) {}
            addSecondary(card, pick);
          })
          .catch(function () {});
      };
      card.addEventListener('mouseenter', pull);
      card.addEventListener('focusin', pull);
      card.addEventListener('touchstart', pull, { passive: true });
      if (mayPrefetch) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          io.disconnect();
          whenIdle(pull);                 // after the resting images have settled
        }, { rootMargin: '250px' });
        io.observe(card);
      }
    }

    // The hover image is transparent but in-viewport, so the browser would fetch
    // it up front and double the page's image weight. Its URLs are parked in
    // data- attributes; move them across the first time the card is approached.
    var hydrated = false;
    function hydrate() {
      if (hydrated || !secondary) return;
      hydrated = true;
      if (shuffle.length) { secondary.setAttribute('src', pickHover()); return; }
      var ss = secondary.getAttribute('data-srcset');
      var s1 = secondary.getAttribute('data-src');
      if (ss) secondary.setAttribute('srcset', ss);
      if (s1) secondary.setAttribute('src', s1);
    }
    // The CSS fade is gated on .pc-ready, so a not-yet-downloaded hover image
    // fades to an empty tile instead of the photo.
    function markReady(){ if (secondary) secondary.classList.add('pc-ready'); }
    if (secondary) {
      if (secondary.complete && secondary.naturalWidth) markReady();
      secondary.addEventListener('load', markReady);
    }
    if (secondary) {
      card.addEventListener('mouseenter', hydrate);
      card.addEventListener('focusin', hydrate);
      card.addEventListener('touchstart', hydrate, { passive: true });
      // Hydrating on mouseenter alone means the first hover waits for the
      // download, which reads as a slow, blank swap. Warm it as soon as the
      // card is near the viewport instead — same treatment the fetched hover
      // images above already get, and still off the critical path: idle time
      // only, and skipped entirely on metered or 2g connections.
      if (mayPrefetch) {
        var ioh = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          ioh.disconnect();
          whenIdle(hydrate);
          // Deliberately wider than the fetch-on-approach observer above: this
          // one only starts an image download, so it is cheap to run early, and
          // 250px is not enough runway when someone scrolls and hovers quickly.
        }, { rootMargin: '900px' });
        ioh.observe(card);
      }
    }

    var pickHover = function () {
      var current = primary.getAttribute('src') || '';
      var pool = shuffle.filter(function (u) { return u !== current; });
      if (!pool.length) pool = shuffle;
      return pool[Math.floor(Math.random() * pool.length)];
    };
    if (shuffle.length && secondary) {
      secondary.removeAttribute('srcset');
      // re-roll AFTER each hover ends — and only once the 0.35s fade-out has
      // finished, so the swap is never visible mid-fade
      card.addEventListener('mouseleave', function () {
        if (!hydrated) return;
        setTimeout(function () {
          if (card.matches(':hover')) return;
          secondary.classList.remove('pc-ready');   // re-armed by the load handler
          secondary.setAttribute('src', pickHover());
        }, 420);
      });
    }
    var resting = primary.getAttribute('src');
    var swatchImgs = [];
    card.querySelectorAll('.pc-sw[data-img]').forEach(function (sw) {
      var img = sw.getAttribute('data-img');
      if (!img) return;
      swatchImgs.push(img);
      sw.addEventListener('mouseenter', function () {
        primary.setAttribute('src', img); primary.removeAttribute('srcset'); card.classList.add('sw-active');
      });
    });
    // Warm the cache the moment the cursor enters the card, so swatch swaps are instant
    var preloaded = false;
    card.addEventListener('mouseenter', function () {
      if (preloaded) return; preloaded = true;
      swatchImgs.concat(shuffle).forEach(function (u) { var i = new Image(); i.src = u; });
    });
    // Image sticks on the last-hovered colour; only reset when leaving the whole card
    card.addEventListener('mouseleave', function () {
      primary.setAttribute('src', resting); card.classList.remove('sw-active');
    });
  }

  function bindCards(root) {
    var found = (root || document).querySelectorAll('.card-product');
    Array.prototype.forEach.call(found, initCard);
  }
  bindCards(document);
  // lets sections that inject cards after load wire up the same hover behaviour
  window.NostalgiaCards = { bind: bindCards };

  // Hero slideshow
  document.querySelectorAll('[data-slideshow]').forEach(function (box) {
    var slides = box.querySelectorAll('.hs-slide');
    if (slides.length < 2) return;
    var delay = parseInt(box.getAttribute('data-interval') || '5000', 10);
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('on');
    }, delay);
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    v += (btn.getAttribute('data-qty') === 'up') ? 1 : -1;
    if (v < 1) v = 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Product variant picker: keep hidden id in sync + price/availability
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-price]') || document.querySelector('[data-price]');
    var compareEl = form.querySelector('[data-compare-price]') || document.querySelector('[data-compare-price]');
    var addBtn = form.querySelector('[data-add]');
    var initialPrice = priceEl ? priceEl.textContent : null;
    // promo-discount rewrites [data-price] into "discounted <s>original</s>".
    // Setting textContent below wipes that, so ask it to redo the sweep rather
    // than duplicating the discount maths and the on-sale rule here.
    function promoRefresh(){ if (window.NLPromo && window.NLPromo.refresh) window.NLPromo.refresh(); }
    var mainImg = document.getElementById('pdp-main');
    var defaultMainSrc = mainImg ? mainImg.src : null;
    // In Shopify's option order, whatever order the fields sit in on the page:
    // every lookup below indexes v.options by position in THIS array, and the
    // section renders Orientation ahead of Size on purpose (it is the choice
    // that changes the picture). data-option-index carries the true position.
    var selectsOnPage = Array.prototype.slice.call(form.querySelectorAll('select[data-option-index]'));
    var selects = selectsOnPage.slice().sort(function (a, b){
      return parseInt(a.getAttribute('data-option-index'), 10) - parseInt(b.getAttribute('data-option-index'), 10);
    });
    var anyAvailable = variants.some(function (v){ return v.available; });

    // Remember every option value from the original markup, per dropdown.
    var allValues = selects.map(function (sel){
      return Array.prototype.slice.call(sel.options)
        .filter(function (o){ return o.value !== ''; })
        .map(function (o){ return o.value; });
    });

    function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
    function selectedOptions(){ return selects.map(function (sel){ return sel.value; }); }

    // A value is offerable if some IN-STOCK variant has it while matching
    // every option already chosen ABOVE it (options below are wildcards).
    // A value is offerable if some IN-STOCK variant has it while matching
    // every OTHER option currently chosen (any dropdown, in any position).
    function offerable(optIndex, value){
      return variants.some(function (v){
        if (!v.available) return false;
        if (v.options[optIndex] !== value) return false;
        for (var j = 0; j < selects.length; j++){
          if (j === optIndex) continue;
          var sv = selects[j].value;
          if (sv && v.options[j] !== sv) return false;
        }
        return true;
      });
    }

    // Which dropdown is which, read from the option name Liquid stamps on the
    // <select> — so this survives a product whose options sit in another order.
    function optionIndexMatching(re){
      for (var i = 0; i < selects.length; i++){
        if (re.test(selects[i].getAttribute('data-option-name') || '')) return i;
      }
      return -1;
    }
    var sizeIdx = optionIndexMatching(/size/i);
    var frameIdx = optionIndexMatching(/framed/i);

    // A0, 16x24 and 30x40 are print-only — nobody makes a frame that big. Left
    // to itself the rebuild above simply drops the frame choices from the list,
    // which reads as "we don't sell frames" rather than "not at this size". So
    // on the framing dropdown ONLY, one greyed-out, unselectable line stands in
    // for the frames the chosen size rules out — one line, not one per colour,
    // because the reason is the same for all of them. Every other dropdown
    // keeps hiding what it can't offer: there the answer is "choose something
    // else first", not "this isn't possible".
    var NOT_FRAMED_LABEL = 'Framed print - unfortunately this size is not available framed.';
    function sizeBlocksFraming(optIndex, value){
      if (frameIdx < 0 || sizeIdx < 0 || optIndex !== frameIdx) return false;
      if (!selects[sizeIdx].value) return false;
      // Only when the SIZE is what rules it out: the frame is sold on this
      // product, and fits every other choice made — just not at this size.
      return variants.some(function (v){
        if (!v.available) return false;
        if (v.options[optIndex] !== value) return false;
        for (var j = 0; j < selects.length; j++){
          if (j === optIndex || j === sizeIdx) continue;
          var sv = selects[j].value;
          if (sv && v.options[j] !== sv) return false;
        }
        return true;
      });
    }

    // Is there an in-stock variant matching every index/value pair in `fixed`?
    function satisfiable(fixed){
      return variants.some(function (v){
        if (!v.available) return false;
        for (var k in fixed){ if (v.options[k] !== fixed[k]) return false; }
        return true;
      });
    }
    // All subsets of `arr` of exactly `size` (arr is small: <= a few option indexes).
    function subsets(arr, size){
      var out = [];
      (function rec(start, chosen){
        if (chosen.length === size){ out.push(chosen.slice()); return; }
        for (var i = start; i < arr.length; i++){ chosen.push(arr[i]); rec(i + 1, chosen); chosen.pop(); }
      })(0, []);
      return out;
    }

    // Price labelling for dropdown options: with the other option(s) chosen the
    // entry is one exact variant ("Black frame — £49"); before that, if prices
    // vary across the possible matches it shows the cheapest ("from £24").
    function priceNum(p){ var m = String(p).replace(/[^0-9.]/g, ''); return m ? parseFloat(m) : Infinity; }
    // The variants JSON holds the undiscounted Liquid prices, so a live promo
    // code would leave these labels contradicting the headline. Route them
    // through NLPromo. Variants already on sale (compare_at set) are left
    // alone, which is promo-discount's rule everywhere else. Note this is for
    // LABELS only — match.price stays raw, because promoRefresh() discounts
    // the headline itself and doing both would take 20% off twice.
    function shownPrice(v){
      if (!v || v.price == null) return v && v.price;
      if (v.compare_at) return v.price;
      return (window.NLPromo && window.NLPromo.price) ? window.NLPromo.price(v.price) : v.price;
    }
    function priceSuffix(optIndex, value){
      // prices only appear once every OTHER dropdown has a selection - i.e. the
      // user is on their last open choice, so every price shown is exact
      var allOthersChosen = true;
      selects.forEach(function (sel, j){ if (j !== optIndex && !sel.value) allOthersChosen = false; });
      if (!allOthersChosen) return '';
      var fixed = {}; fixed[optIndex] = value;
      selects.forEach(function (sel, j){ if (j !== optIndex && sel.value) fixed[j] = sel.value; });
      var prices = [];
      variants.forEach(function (v){
        if (!v.available || v.price == null) return;
        for (var k in fixed){ if (v.options[k] !== fixed[k]) return; }
        var shown = shownPrice(v);
        if (prices.indexOf(shown) === -1) prices.push(shown);
      });
      if (!prices.length) return '';
      if (prices.length === 1) return ' \u2014 ' + prices[0];
      prices.sort(function (a, b){ return priceNum(a) - priceNum(b); });
      return ' \u2014 from ' + prices[0];
    }

    // Keep the just-changed dropdown ("anchor") fixed, and preserve as many of the
    // OTHER current selections as can still coexist with it; clear only the rest.
    function reconcile(anchor){
      if (!anyAvailable) return;
      if (anchor != null && selects[anchor] && selects[anchor].value){
        var others = [];
        selects.forEach(function (sel, i){ if (i !== anchor && sel.value) others.push(i); });
        var best = [];
        for (var size = others.length; size >= 0; size--){
          var found = subsets(others, size).some(function (subset){
            var fixed = {}; fixed[anchor] = selects[anchor].value;
            subset.forEach(function (i){ fixed[i] = selects[i].value; });
            if (satisfiable(fixed)){ best = subset; return true; }
            return false;
          });
          if (found) break;
        }
        others.forEach(function (i){ if (best.indexOf(i) === -1) selects[i].value = ''; });
      } else {
        // No anchor (init / anchor cleared): drop any globally-inconsistent picks.
        for (var pass = 0; pass < selects.length; pass++){
          var changed = false;
          selects.forEach(function (sel, i){ if (sel.value && !offerable(i, sel.value)){ sel.value = ''; changed = true; } });
          if (!changed) break;
        }
      }
      // Rebuild each dropdown to list only options compatible with the others.
      selects.forEach(function (sel, i){
        var current = sel.value;
        // data-placeholder lets a page name its own (the lyric page's desktop layout
        // drops the field labels, so its dropdowns say what they are).
        var html = '<option value=""' + (current ? '' : ' selected') + '>' + esc(sel.getAttribute('data-placeholder') || 'Please select…') + '</option>';
        var keep = false;
        var framesRuledOut = false;
        allValues[i].forEach(function (val){
          if (offerable(i, val)){
            var sfx = priceSuffix(i, val);
            html += '<option value="' + esc(val) + '" data-suffix="' + esc(sfx) + '"' + (val === current ? ' selected' : '') + '>' + esc(val) + esc(sfx) + '</option>';
            if (val === current) keep = true;
            return;
          }
          if (sizeBlocksFraming(i, val)) framesRuledOut = true;
        });
        // Valueless as well as disabled, so it can never be chosen, submitted,
        // or land in the closed field — it is a message, not an option.
        if (framesRuledOut) html += '<option value="" disabled data-note="' + esc(NOT_FRAMED_LABEL) + '">' + esc(NOT_FRAMED_LABEL) + '</option>';
        sel.innerHTML = html;
        if (current && !keep) sel.value = '';
      });
      stripPrices();
    }

    // The closed field shows the selected option's text — keep that clean.
    // Prices live in the open list only: restored on open, stripped on choose.
    function stripPrices(){
      selects.forEach(function (sel){
        var o = sel.options[sel.selectedIndex];
        if (o && o.value) o.textContent = o.value;
      });
    }
    function restorePrices(sel){
      // Recomputed at open time rather than read from the cached data-suffix:
      // promo-discount resolves the live code asynchronously (it waits on
      // /cart.js), so a suffix built during the first reconcile can predate it.
      var idx = selects.indexOf(sel);
      Array.prototype.forEach.call(sel.options, function (o){
        if (o.disabled){ if (o.getAttribute('data-note')) o.textContent = o.getAttribute('data-note'); return; }
        if (!o.value) return;
        var sfx = idx > -1 ? priceSuffix(idx, o.value) : (o.getAttribute('data-suffix') || '');
        o.setAttribute('data-suffix', sfx);
        o.textContent = o.value + sfx;
      });
    }
    selects.forEach(function (sel){
      sel.addEventListener('mousedown', function (){ restorePrices(sel); });
      sel.addEventListener('keydown', function (e){ if (e.altKey || e.key === 'Enter' || e.key === ' ') restorePrices(sel); });
      sel.addEventListener('blur', stripPrices);
      sel.addEventListener('change', stripPrices);
    });

    function hideFlag(sel){ var fld = sel.closest('.field'); var f = fld && fld.querySelector('.req-flag'); if (f && sel.value) f.hidden = true; if (sel.value) sel.removeAttribute('aria-invalid'); }

    function update(){
      // Button is ALWAYS an enabled persimmon "Add to cart" while anything is buyable.
      // An incomplete selection is caught on submit (reveals PLEASE SELECT flags),
      // never by disabling or relabelling the button.
      if (!anyAvailable){ if (addBtn){ addBtn.disabled = true; addBtn.textContent = 'Sold out'; } return; }
      if (addBtn){ addBtn.disabled = false; addBtn.textContent = 'Add to cart'; }
      selects.forEach(hideFlag);            // a filled group never keeps its flag
      var opts = selectedOptions();
      if (!opts.every(function (o){ return o; })){
        // incomplete (e.g. deselected back to "Please select…"): show the range again
        if (priceEl && initialPrice != null && priceEl.textContent !== initialPrice) priceEl.textContent = initialPrice;
        if (compareEl) compareEl.style.display = 'none';
        promoRefresh();
        return;
      }
      var match = variants.find(function (v){ return v.options.every(function (o, k){ return o === opts[k]; }); });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl && match.price != null && priceEl.textContent !== match.price) priceEl.textContent = match.price;
      if (compareEl){ if (match.compare_at){ compareEl.textContent = match.compare_at; compareEl.style.display = ''; } else { compareEl.style.display = 'none'; } }
      // After compareEl's visibility is settled, so the on-sale check sees truth.
      promoRefresh();
    }

    // Block submit + reveal PLEASE SELECT / PLEASE PROVIDE only when
    // something is still unchosen or an inline personalisation is empty.
    var reqInputs = Array.prototype.slice.call(form.querySelectorAll('input[data-req-input]'));
    form.addEventListener('submit', function (e){
      if (!anyAvailable) return;
      var incomplete = selects.some(function (sel){ return !sel.value; });
      var missing = reqInputs.filter(function (inp){ return !inp.value.trim(); });
      if (!incomplete && !missing.length) return;
      e.preventDefault();
      selects.forEach(function (sel){
        var fld = sel.closest('.field'); var f = fld && fld.querySelector('.req-flag');
        if (f) f.hidden = Boolean(sel.value);
        if (sel.value) sel.removeAttribute('aria-invalid'); else sel.setAttribute('aria-invalid', 'true');
      });
      reqInputs.forEach(function (inp){
        var fld = inp.closest('.field'); var f = fld && fld.querySelector('.req-flag');
        if (f) f.hidden = Boolean(inp.value.trim());
      });
      // the first empty field as the customer reads the page, not in option order
      var firstEmpty = selectsOnPage.filter(function (s){ return !s.value; })[0] || missing[0];
      if (firstEmpty) firstEmpty.focus();
    });
    // Typing into a flagged personalisation clears its flag straight away.
    reqInputs.forEach(function (inp){
      inp.addEventListener('input', function (){
        if (!inp.value.trim()) return;
        var fld = inp.closest('.field'); var f = fld && fld.querySelector('.req-flag');
        if (f) f.hidden = true;
      });
    });

    /* Only products whose VARIANTS carry photos of their own get their gallery
       moved by the dropdowns. Where none of them do — the lyric prints, whose
       fifteen colourway photos belong to the product rather than to any size —
       the old code still ran, found nothing to show, and reset the gallery to
       the first photo. So browsing to the colourway you liked and then choosing
       a size threw you back to photo one. */
    /* A variant photo whose filename carries `--cart-` exists for the cart line,
       the confirmation email and Shopify's checkout - see the VARIANT-ONLY PHOTOS
       note in snippets/product-gallery.liquid. It is not in the strip, so putting
       it on screen would strand the thumbnail highlight and send the arrows back
       to photo one. The live preview owns that job here; these are invisible to
       the gallery. */
    function galleryImage(v){
      return v.image && v.image.indexOf('--cart-') === -1 ? v.image : null;
    }
    function updateImage(){
      if (!mainImg || !variants.some(galleryImage)) return;
      var opts = selectedOptions();
      if (!opts.some(function (o){ return o; })){ mainImg.src = defaultMainSrc; return; }
      var matching = variants.filter(function (v){ return v.options.every(function (o, k){ return !opts[k] || o === opts[k]; }); });
      var imgs = [];
      matching.forEach(function (v){ var s = galleryImage(v); if (s && imgs.indexOf(s) === -1) imgs.push(s); });
      mainImg.src = imgs.length === 1 ? imgs[0] : defaultMainSrc;
    }

    form.addEventListener('change', function (e){
      var sel = e.target.closest('select[data-option-index]');
      if (!sel) return;
      reconcile(selects.indexOf(sel));
      update();
      updateImage();
    });

    // Wishlist links land with ?variant= — preselect that exact choice.
    var pv = parseInt(new URLSearchParams(location.search).get('variant'), 10);
    if (pv) {
      var chosen = variants.find(function (v) { return v.id === pv; });
      if (chosen) selects.forEach(function (sel, k) { if (chosen.options[k] != null) sel.value = chosen.options[k]; });
    }
    reconcile();
    update();
    updateImage();

    /* ---- Layout: the same print as a different product ----
       A movie print's three layouts (full / title & year / barcode only) are
       three products, because the print supplier maps artwork per variant -
       see the LAYOUTS note in sections/main-product.liquid. The section
       renders every layout's variant list, so choosing one here is a swap of
       `variants`, not a page load: the size and framing already picked carry
       straight over, because the families share one option set. The gallery
       is told to show that layout's thumbnail run, the title follows, and the
       URL is rewritten to the product that will actually go in the cart, so a
       refresh, a share or the wishlist all land on what was chosen. */
    var layoutSel = form.querySelector('select[data-layout-select]');
    if (layoutSel) {
      var layouts = {};
      layouts[dataEl.getAttribute('data-layout') || 'full'] = dataEl;
      Array.prototype.forEach.call(form.querySelectorAll('[data-layout-variants]'), function (el){
        layouts[el.getAttribute('data-layout')] = el;
      });
      var saveBtn = document.querySelector('[data-save][data-handle]');
      function switchLayout(name){
        var el = layouts[name];
        if (!el) return;
        variants = JSON.parse(el.textContent);
        anyAvailable = variants.some(function (v){ return v.available; });
        // the gallery: show this layout's run, hide the others, then let the
        // gallery script re-read the strip
        Array.prototype.forEach.call(document.querySelectorAll('.pdp-thumb[data-layout], .pdp-slide[data-layout]'), function (b){
          b.hidden = b.getAttribute('data-layout') !== name;
        });
        document.dispatchEvent(new CustomEvent('pdp:layout', { detail: { layout: name } }));
        // the variant JSON's default photo is now this layout's first shot
        if (mainImg) defaultMainSrc = mainImg.src;
        reconcile();
        update();
        updateImage();
        // the heading is the film's title on every layout - see main-product.liquid
        if (saveBtn && el.getAttribute('data-handle')) saveBtn.setAttribute('data-handle', el.getAttribute('data-handle'));
        var url = el.getAttribute('data-url');
        if (url && window.history && history.replaceState) {
          var complete = selectedOptions().every(function (o){ return o; });
          history.replaceState(null, '', url + (complete && idInput && idInput.value ? '?variant=' + idInput.value : ''));
        }
      }
      layoutSel.addEventListener('change', function (){ switchLayout(layoutSel.value); });
    }
  });
})();


/* ---- The price on the buy button (phones) ----
   On a phone the headline price sits under the title, and every dropdown
   stacks between it and the button, so by the time the last choice is made
   the price has usually scrolled off the top. Once every option is chosen the
   button carries it as well: "Add to cart · £24".

   Four rules:
   - Only with EVERY option chosen. Before that the headline is a range, and
     "Add to cart · £19–£89" says nothing a shopper can act on.
   - The same figure as the headline, read off it, so a live promo code (which
     promo-discount writes into [data-price] as "now <s>was</s>") shows the
     discounted price, and there is no second copy of the discount maths.
   - Quantity 1 only. The buy-2/buy-3 saving is taken at checkout, and
     quantity-discount.liquid is built never to quote a figure checkout might
     disagree with: "£24" beside a 2 is unclear and "£48" would be wrong. At 2+
     the label says how many instead - "Add 2 to cart" - and carries no price.
   - Phones only (<=760px, where the PDP stacks). The price is an ATTRIBUTE
     painted by CSS (see [data-cta-price] in base.css), not button text: the
     variant picker rewrites the text to "Add to cart" on every change and
     lyric-pdp.js swaps in "Update" / "Saving your design…", so text would be
     overwritten or would clobber theirs. The "Add N" label IS text, so it is
     only ever written over one of the two plain labels, never over anyone
     else's.

   Binds to any product form with a [data-add] button: movies, travel, sport
   and patents (main-product) and the lyric prints. The run map page has no
   [data-add] - its price already sits beside its button. The deck's real
   button is inside the customiser overlay; see deck-customiser-product. */
(function () {
  var PHONE = window.matchMedia ? window.matchMedia('(max-width: 760px)') : null;
  var PLAIN = /^Add (\d+ )?to cart$/;
  Array.prototype.forEach.call(document.querySelectorAll('form[data-product-form]'), function (form) {
    var btn = form.querySelector('[data-add]');
    var priceEl = form.querySelector('[data-price]') || document.querySelector('[data-price]');
    if (!btn || !priceEl) return;
    var qty = form.querySelector('input[name="quantity"]');

    function headline() {
      var c = priceEl.cloneNode(true);
      Array.prototype.forEach.call(c.querySelectorAll('.nl-promo-was'), function (s) { s.parentNode.removeChild(s); });
      return c.textContent.replace(/\s+/g, ' ').trim();
    }
    function paint() {
      var complete = Array.prototype.every.call(form.querySelectorAll('select[data-option-index]'), function (s) { return !!s.value; });
      var n = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
      var phone = !!(PHONE && PHONE.matches);
      var text = btn.textContent.trim();
      if (!btn.disabled && PLAIN.test(text)) {
        var want = (phone && n > 1) ? 'Add ' + n + ' to cart' : 'Add to cart';
        if (text !== want) btn.textContent = want;
      }
      var p = headline();
      // a range (en dash) or anything without a figure in it is not a price
      var show = complete && n === 1 && /\d/.test(p) && !/[–—]/.test(p);
      if (!show) { btn.removeAttribute('data-cta-price'); return; }
      if (btn.getAttribute('data-cta-price') !== p) btn.setAttribute('data-cta-price', p);
    }

    // Registered after the variant picker's own listener, so this runs after
    // it has settled the headline and reset the label.
    form.addEventListener('change', paint);
    if (qty) qty.addEventListener('input', paint);
    // The promo sweep rewrites the headline asynchronously (it waits on
    // /cart.js). Only the headline is observed and only the button is written,
    // so this can never trigger itself.
    if (window.MutationObserver) {
      new MutationObserver(paint).observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
    if (PHONE) {
      if (PHONE.addEventListener) PHONE.addEventListener('change', paint);
      else if (PHONE.addListener) PHONE.addListener(paint);
    }
    paint();
  });
})();

/* Predictive (instant) search */
/* DISABLED until tested: flip PS_ENABLED to true to go live */
var PS_ENABLED = true;
(function () {
  if (!PS_ENABLED) return;
  // Every form.search on the page gets its own dropdown and its own state —
  // the header field on desktop, the drawer field on a phone. Was a single
  // querySelector, which bound the header form and left the drawer's dead.
  Array.prototype.forEach.call(document.querySelectorAll('form.search'), function (form) {
  var input = form.querySelector('input[name="q"]');
  var box = form.querySelector('[data-ps]');
  if (!input || !box) return;
  var timer, controller;
  var spin = form.querySelector('[data-ps-spin]');
  var seq = 0;              // request counter, so a slow reply can't overwrite a newer one
  var shownFor = '';        // the term the dropdown is currently showing results for
  function esc(s){ return (s == null ? '' : String(s)).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function money(v){ var n = parseFloat(v); if (isNaN(n)) return ''; return '\u00A3' + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, ''); }
  function priceHtml(p){ if (p.lo !== p.hi) return money(p.lo / 100) + '\u2013' + money(p.hi / 100); return money(p.lo / 100); }
  function close(){ box.hidden = true; setBusy(false); }
  /* Busy state: a spinner in the search bar. The lookup hits two endpoints and
     can take a couple of seconds, so it needs to look like it is doing something. */
  function setBusy(on){
    form.classList.toggle('ps-busy', !!on);
    if (spin) spin.hidden = !on;
  }
  /* Placeholder rows, so the dropdown opens the instant you type rather than
     after the network settles. Only used when there is nothing to keep on show. */
  function skeleton(){
    var row = '<li class="ps-skel"><span class="ps-thumb"></span>'
      + '<span class="ps-info"><span class="ps-skel-line w1"></span><span class="ps-skel-line w2"></span></span></li>';
    box.innerHTML = '<ul class="ps-list" role="status" aria-live="polite" aria-label="Searching">'
      + row + row + row + '</ul>';
    box.hidden = false;
  }
  function itemHtml(p){
    var img = p.img || '';
    return '<li><a class="ps-item" href="' + esc(p.url) + '">'
      + '<span class="ps-thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>'
      + '<span class="ps-info"><span class="ps-title">' + esc(p.title) + '</span>'
      + '<span class="ps-price">' + priceHtml(p) + '</span></span></a></li>';
  }
  function render(products, term, people){
    products = (products || []).slice().sort(function(a,b){ return String(a.title || '').localeCompare(String(b.title || '')); });
    people = people || [];
    if (!products.length && !people.length){ box.innerHTML = '<div class="ps-empty">No matches for \u201C' + esc(term) + '\u201D</div>'; box.hidden = false; return; }
    var html = '', seen = {};
    people.forEach(function (per) {
      var items = (per.products || []).map(function (p) {
        return { title: p.t, url: '/products/' + p.h, img: p.img ? p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '', lo: p.lo, hi: p.hi };
      });
      if (!items.length) return;
      var cap = esc(per.name) + (per.total > 1 ? ' \u00B7 ' + per.total + ' prints' : '');
      html += '<div class="ps-cap">' + cap + '</div><ul class="ps-list">';
      items.forEach(function (p) { seen[p.url] = 1; html += itemHtml(p); });
      html += '</ul>';
      if (per.total > items.length) {
        html += '<a class="ps-all" href="/search?q=' + encodeURIComponent(per.name) + '&type=product">All ' + per.total + ' prints featuring ' + esc(per.name) + '</a>';
      }
    });
    var rest = products.filter(function (p) { return !seen[p.url]; });
    if (rest.length) {
      if (people.length) html += '<div class="ps-cap">Prints</div>';
      html += '<ul class="ps-list">' + rest.map(itemHtml).join('') + '</ul>';
    }
    html += '<a class="ps-all" href="/search?q=' + encodeURIComponent(term) + '">See all results for \u201C' + esc(term) + '\u201D</a>';
    box.innerHTML = html; box.hidden = false;
  }
  function run(){
    var q = input.value.trim();
    // Format words out before the query goes anywhere, same rule as the results
    // page (snippets/search-boot.liquid). The dropdown and /search must agree.
    var NL = window.NLSearch;
    var cleaned = NL ? NL.clean(q) : null;
    var sq = (cleaned && cleaned.q) ? cleaned.q : q;
    if (q.length < 2){
      // bump seq and abort, or a reply already on its way would re-open the
      // dropdown with results for text that has since been deleted
      seq++;
      if (controller) controller.abort();
      box.innerHTML = ''; shownFor = ''; close();
      return;
    }
    if (controller) controller.abort();
    // Nothing but format words ("poster", "wall art"). Every print qualifies,
    // so there is no list to show - only the way through to all of them.
    if (cleaned && cleaned.empty) {
      seq++;
      box.innerHTML = '<a class="ps-all" href="' + NL.ALL_URL + '">Browse all prints</a>';
      box.hidden = false; setBusy(false); shownFor = q;
      return;
    }
    controller = new AbortController();
    var mine = ++seq;
    setBusy(true);
    // A word that names a shelf ("marvel"). Shopify search would answer with
    // bridges and bassoons, so show the collection built for it instead - its
    // first page, and the way through to all of it. Same rule as the results
    // page (ROUTES in snippets/search-boot.liquid); Enter lands on the same URL.
    var route = (NL && NL.route) ? NL.route(sq) : null;
    // "marvel iron man": a search, held to the shelf's tag (the psHit prefix
    // below), for the words that were not the shelf. Same as the results page.
    var shelfTag = '';
    if (route && route.rest) { shelfTag = 'tag:"' + route.tag + '" '; sq = route.rest; route = null; }
    if (route) {
      if (box.hidden || !box.innerHTML.trim()) skeleton();
      var routeGiveUp = setTimeout(function(){ if (mine === seq) { controller.abort(); setBusy(false); } }, 8000);
      fetch(route.url + '?view=ps', { signal: controller.signal })
        .then(function (r) { return r.json(); }).catch(function () { return null; })
        .then(function (r) {
          clearTimeout(routeGiveUp);
          if (mine !== seq) return;
          setBusy(false);
          if (r === null) return;                                                          // aborted
          shownFor = q;
          var items = (r && r.results) || [];
          var total = (r && r.total) || items.length;
          var html = '<div class="ps-cap">' + esc(route.name) + (total > 1 ? ' \u00B7 ' + total + ' prints' : '') + '</div>';
          if (items.length) html += '<ul class="ps-list">' + items.map(itemHtml).join('') + '</ul>';
          html += '<a class="ps-all" href="' + esc(route.url) + '">All ' + total + ' ' + esc(route.name) + ' prints</a>';
          box.innerHTML = html; box.hidden = false;
        });
      return;
    }
    // Keep whatever is already on screen if there is anything — replacing real
    // results with shimmer on every keystroke reads as flicker, not progress.
    if (box.hidden || !box.innerHTML.trim()) skeleton();
    // A request that never settles must not leave the spinner turning forever.
    var giveUp = setTimeout(function(){
      if (mine !== seq) return;
      if (controller) controller.abort();
      setBusy(false);
    }, 8000);
    var API = 'https://nostalgia-loved.nostalgiacouk.workers.dev';
    // same engine as the results page (templates/search.ps.liquid), so the
    // dropdown and the results page can never disagree
    function psHit(term){
      // Plain words only. "-tag:hidden-style" used to go in here, but Shopify ORs
      // terms, so it matched every product without the tag. The ps template
      // filters siblings and non-matches itself (snippets/search-match.liquid).
      return fetch('/search?view=ps&type=product&q=' + encodeURIComponent(shelfTag + term), { signal: controller.signal })
        .then(function (r) { return r.json(); }).catch(function () { return null; });
    }
    // Plain words first; a trailing * (prefix match) only when that finds no real
    // match - "jur" finds Jurassic Park on the second try. Same order as the
    // results page.
    function psSearch(term){
      return psHit(term).then(function (r) {
        if (r && r.results && r.results.length) return r;
        return psHit(term + '*').then(function (r2) {
          return (r2 && r2.results && r2.results.length) ? r2 : r;
        });
      });
    }
    Promise.all([
      psSearch(sq),
      // the people lane: whole-word name matching from the Worker's index
      fetch(API + '/api/people?q=' + encodeURIComponent(sq), { signal: controller.signal })
        .then(function (r) { return r.ok ? r.json() : { matches: [] }; }).catch(function () { return { matches: [] }; })
    ]).then(function (res) {
      clearTimeout(giveUp);
      if (mine !== seq) return;                                                              // superseded by a newer keystroke
      setBusy(false);
      if (res[0] === null && !(res[1] && res[1].matches && res[1].matches.length)) return;   // aborted
      shownFor = q;
      render((res[0] && res[0].results) || [], q, (res[1] && res[1].matches) || []);
    }).catch(function () { clearTimeout(giveUp); if (mine === seq) setBusy(false); });
  }
  input.addEventListener('input', function () {
    clearTimeout(timer);
    // Show the spinner from the first keystroke, not only once the fetch fires —
    // the debounce is part of the wait as far as anyone typing is concerned.
    if (input.value.trim().length >= 2) setBusy(true); else { setBusy(false); shownFor = ''; }
    timer = setTimeout(run, 200);
  });
  input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && box.innerHTML.trim()) box.hidden = false; });
  function dismiss(){ clearTimeout(timer); if (controller) controller.abort(); seq++; close(); }
  document.addEventListener('click', function (e) { if (!form.contains(e.target)) dismiss(); });
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape') dismiss(); });
  });
})();


/* Hearts — product cards AND the product-page save button, one module.
   Which prints are MINE lives in localStorage; the public counts come from
   the loved Worker (batched, one request per page). If the Worker is
   unreachable, counts simply stay hidden — hearts still work locally.
   window.NostalgiaLoves.{bind,seed} lets other scripts (Most loved sort)
   wire up cards they inject after page load. */
(function () {
  var KEY = 'nostalgia:saved';
  var EVER = 'nostalgia:ever';   // prints this browser has EVER loved (lifetime counter guard)
  var API = 'https://nostalgia-loved.nostalgiacouk.workers.dev';
  function savedSet() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function everSet() { try { return JSON.parse(localStorage.getItem(EVER)) || {}; } catch (e) { return {}; } }
  // seed: anything currently loved has, by definition, been loved
  (function () {
    var ever = everSet(), seeded = false, saved = savedSet();
    for (var k in saved) { if (!ever[k]) { ever[k] = 1; seeded = true; } }
    if (seeded) { try { localStorage.setItem(EVER, JSON.stringify(ever)); } catch (e) {} }
  })();
  // Love counts are never shown to shoppers - they only rank the
  // "Most loved" sorts, which the Worker orders server-side.
  var counts = {};
  var btns = [];
  function paint(btn) {
    var handle = btn.getAttribute('data-handle') || '';
    var on = !!savedSet()[handle];
    btn.classList.toggle('on', on);      // card hearts
    btn.classList.toggle('saved', on);   // product-page disc
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  function wire(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-handle') || '';
      var all = savedSet();
      var on = !all[handle];
      if (on) all[handle] = 1; else delete all[handle];
      try { localStorage.setItem(KEY, JSON.stringify(all)); } catch (e2) {}
      // Lifetime counts: only a browser's FIRST-EVER love of a print bumps the
      // public number. Un-loving (and re-loving) leaves it untouched.
      var ever = everSet();
      if (on && !ever[handle]) {
        ever[handle] = 1;
        try { localStorage.setItem(EVER, JSON.stringify(ever)); } catch (e3) {}
        counts[handle] = (typeof counts[handle] === 'number' ? counts[handle] : 0) + 1;
        // text/plain keeps this a "simple" request — no CORS preflight round-trip
        fetch(API + '/api/love', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ handle: handle, on: true }) }).catch(function () {});
      }
      // The ogres Loved page: every heart, with the paths beacon's anonymous
      // visitor id (absent if analytics were refused), so it can show who is
      // hearting what and whether they went on to order. Fire and forget.
      if (on) {
        try {
          var nlp = window.NLPaths || {};
          var lb = JSON.stringify({ h: handle, vid: nlp.vid || '', sid: nlp.sid || '' });
          var LURL = 'https://nostalgia-stats.nostalgiacouk.workers.dev/v/love';
          if (!(navigator.sendBeacon && navigator.sendBeacon(LURL, new Blob([lb], { type: 'text/plain' }))))
            fetch(LURL, { method: 'POST', body: lb, keepalive: true, mode: 'no-cors' }).catch(function () {});
        } catch (e4) {}
      }
      btns.forEach(function (b) { if (b.getAttribute('data-handle') === handle) paint(b); });
      // signed in? mirror the change to the account copy (via the App Proxy)
      if (window.NLCustomer) {
        fetch('/apps/loved/love', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ handle: handle, on: on }) }).catch(function () {});
      }
      document.dispatchEvent(new CustomEvent('nostalgia:loved-changed', { detail: { on: on } }));
    });
  }
  function bind(root) {
    var found = (root || document).querySelectorAll('[data-heart], [data-save]');
    Array.prototype.forEach.call(found, function (el) {
      if (el.getAttribute('data-nl-bound')) return;
      el.setAttribute('data-nl-bound', '1');
      btns.push(el);
      wire(el);
      paint(el);
    });
  }
  function seed(map) {
    for (var k in map) counts[k] = map[k];
    btns.forEach(paint);
  }
  window.NostalgiaLoves = { bind: bind, seed: seed };
  bind(document);
  document.addEventListener('nostalgia:loved-synced', function () { btns.forEach(paint); });
})();

/* Loved tab (earned side handle) + save-moment toast.
   The tab doesn't exist until the first love; count = number of loved prints. */
(function () {
  var KEY = 'nostalgia:saved';
  function lovedCount() { try { return Object.keys(JSON.parse(localStorage.getItem(KEY)) || {}).length; } catch (e) { return 0; } }
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';
  var tab = document.createElement('a');
  tab.className = 'loved-tab';
  tab.href = '/pages/loved';
  tab.hidden = true;
  tab.setAttribute('aria-label', 'Your loved prints');
  tab.innerHTML = '<span class="tab">' + HEART + '<span class="ct"></span><span class="lbl">Your loved prints</span></span>';
  document.body.appendChild(tab);
  var toast = document.createElement('div');
  toast.className = 'loved-toast';
  toast.setAttribute('role', 'status');
  document.body.appendChild(toast);
  var toastTimer = null;
  function paintTab() {
    var n = lovedCount();
    tab.querySelector('.ct').textContent = n;
    tab.hidden = n < 1;
  }
  function animate(cls) {
    tab.classList.remove('anim-in', 'anim-bump');
    void tab.offsetWidth;   // restart the animation even on rapid loves
    tab.classList.add(cls);
  }
  tab.addEventListener('animationend', function (e) { if (e.target === tab) tab.classList.remove('anim-in', 'anim-bump'); });
  document.addEventListener('nostalgia:loved-synced', function () { paintTab(); });
  document.addEventListener('nostalgia:loved-changed', function (e) {
    var wasHidden = tab.hidden;
    paintTab();
    var on = !!(e.detail && e.detail.on);
    if (!tab.hidden) {
      if (wasHidden) animate('anim-in');        // a) first love: slide in from the edge
      else if (on) animate('anim-bump');        // b) another love: nudge + heartbeat + count pop
    }
    toast.innerHTML = HEART + '<span>' + (on ? 'Added to your loved prints' : 'Removed from your loved prints') + '</span><a href="/pages/loved">View</a>';
    placeToast();
    toast.classList.add('in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('in'); }, 2600);
  });
  /* Every width: hang the toast under the header heart (see .at-heart in base.css).
     The header is sticky and condenses on scroll, so it is measured on every
     show and again on scroll while the toast is up. */
  function placeToast() {
    var h = document.querySelector('.htop-util .hloved');
    var r = h && h.getBoundingClientRect();
    if (!r || !r.width || r.bottom < 0) {
      toast.classList.remove('at-heart');
      toast.style.top = toast.style.right = '';
      toast.style.removeProperty('--tip');
      return;
    }
    var right = Math.max(10, Math.round(window.innerWidth - r.right - 4));
    toast.classList.add('at-heart');
    toast.style.top = Math.round(r.bottom + 8) + 'px';
    toast.style.right = right + 'px';
    var tip = Math.round(window.innerWidth - (r.left + r.width / 2) - right - 5);
    toast.style.setProperty('--tip', Math.max(10, tip) + 'px');
  }
  window.addEventListener('scroll', function () { if (toast.classList.contains('in')) placeToast(); }, { passive: true });
  paintTab();

  /* Never sit ON TOP OF the buy button — and nothing stronger than that.
     The tab is the only route back to the loved page, so it has to stay
     reachable; the rule here is purely about not covering Add to cart (or the
     customisers' "Customise my..." button).
     On a phone the tab is bottom-right and the button scrolls straight under
     it, so they genuinely collide. On desktop the button sits inside the page
     container and the tab is out at the window edge, so they never meet — an
     earlier version faded the tab out whenever the button was merely on screen,
     which on a desktop product page meant it vanished the instant you loved
     something and never came back. So: test for an actual overlap of the two
     boxes, not for the button being visible.
     Same reasoning as the cart-page rule in base.css, applied per-scroll. */
  (function () {
    var buys = document.querySelectorAll('[data-add], .deck-cta, .pdp-buy button[type="submit"], .pdp-buy .btn[name="add"]');
    if (!buys.length) return;
    var GAP = 12;   // breathing room, so the two never quite touch
    function restRect() {
      // .clear parks the tab off the right edge, so a cleared tab would measure
      // as "miles away" and instantly un-clear itself. Neutralise the transform
      // for the measurement — set and reverted in one go, so nothing repaints.
      var cleared = tab.classList.contains('clear');
      if (cleared) tab.style.transform = 'none';
      var r = tab.getBoundingClientRect();
      if (cleared) tab.style.transform = '';
      return r;
    }
    var queued = false;
    function check() {
      queued = false;
      if (tab.hidden) return;            // nothing to protect the button from yet
      // Mid slide-in the tab is somewhere between the edge and its resting
      // place, and a CSS animation outranks the inline transform above, so it
      // cannot be measured yet. The animationend below re-runs this.
      if (tab.classList.contains('anim-in') || tab.classList.contains('anim-bump')) return;
      var a = restRect(), hit = false;
      Array.prototype.forEach.call(buys, function (b) {
        if (hit) return;
        var r = b.getBoundingClientRect();
        if (!r.width && !r.height) return;                        // not rendered
        if (r.bottom < 0 || r.top > window.innerHeight) return;   // off screen
        hit = !(r.right < a.left - GAP || r.left > a.right + GAP
             || r.bottom < a.top - GAP || r.top > a.bottom + GAP);
      });
      tab.classList.toggle('clear', hit);
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    // the tab appearing for the first time changes what there is to test
    document.addEventListener('nostalgia:loved-changed', queue);
    tab.addEventListener('animationend', function (e) { if (e.target === tab) queue(); });
    queue();
  })();
})();

/* Hearts: say what they do.
   A bare heart is a guess — like? favourite? does it even do anything? — and
   the answer only shows up after you have already clicked. So hovering one for
   a beat spells it out, and the wording changes with the state so it doubles as
   "click again to remove".
   Pointer-fine only: on a touch screen a hover IS the start of a tap, and the
   tip would flash on every single love. The 400ms delay means a hover on the
   way to clicking never sees it either — this is for the shopper who paused. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  var SEL = '[data-heart],[data-save]';
  var tip = document.createElement('div');
  tip.className = 'nl-tip';
  tip.setAttribute('role', 'tooltip');
  document.body.appendChild(tip);
  var timer = null, current = null;
  function wording(btn) {
    return btn.getAttribute('aria-pressed') === 'true'
      ? 'In your loved prints — click to remove'
      : 'Love it to save it for later';
  }
  function show(btn) {
    tip.textContent = wording(btn);
    // measure first, then place: the text length decides the width, and the
    // width decides whether it has to slide in off the edge of the window
    tip.style.visibility = 'hidden';
    tip.classList.add('on');
    var r = btn.getBoundingClientRect(), w = tip.offsetWidth, h = tip.offsetHeight;
    var left = Math.max(8, Math.min(r.left + r.width / 2 - w / 2, window.innerWidth - w - 8));
    var top = r.bottom + 10;
    if (top + h > window.innerHeight - 8) top = r.top - h - 10;   // flip above near the fold
    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(top) + 'px';
    tip.style.visibility = '';
  }
  function hide() { clearTimeout(timer); current = null; tip.classList.remove('on'); }
  document.addEventListener('mouseover', function (e) {
    var t = e.target, btn = t && t.closest ? t.closest(SEL) : null;
    if (!btn || btn === current) return;
    current = btn;
    clearTimeout(timer);
    timer = setTimeout(function () { if (current === btn) show(btn); }, 400);
  });
  document.addEventListener('mouseout', function (e) {
    // moving between the button's own children is not leaving it
    if (!current) return;
    var to = e.relatedTarget;
    if (to && current.contains && current.contains(to)) return;
    var t = e.target, btn = t && t.closest ? t.closest(SEL) : null;
    if (btn === current) hide();
  });
  // a click has just answered the question, and the toast says the rest
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest(SEL)) hide();
  }, true);
  window.addEventListener('scroll', function () { if (current) hide(); }, { passive: true });
})();


/* Account sync — when signed in, merge this device's loves with the account
   copy (once per browsing session) so loves follow the customer across
   devices. The union comes back and becomes the device list. */
(function () {
  if (!window.NLCustomer) return;
  var KEY = 'nostalgia:saved';
  if (sessionStorage.getItem('nostalgia:synced')) return;
  // First visit as this customer on this device: contribute local loves (union).
  // After that the ACCOUNT is the source of truth — so an un-love made on one
  // device can't be resurrected by another device's stale local copy.
  var mergedFlag = 'nostalgia:merged:' + window.NLCustomer;
  var firstMerge = !localStorage.getItem(mergedFlag);
  var local = {};
  try { local = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) {}
  var req = firstMerge
    ? fetch('/apps/loved/sync', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ loved: Object.keys(local) }) })
    : fetch('/apps/loved/me');
  req.then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
    if (!data || !Array.isArray(data.loved)) return;
    try { sessionStorage.setItem('nostalgia:synced', '1'); } catch (e) {}
    if (firstMerge) { try { localStorage.setItem(mergedFlag, '1'); } catch (e) {} }
    var merged = {};
    data.loved.forEach(function (x) { merged[x] = 1; });
    try { localStorage.setItem(KEY, JSON.stringify(merged)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('nostalgia:loved-synced', { detail: { loved: data.loved } }));
    // claim any wishlists made before signing in — their links stay live
    var anonWls = [];
    try { anonWls = JSON.parse(localStorage.getItem('nostalgia:wishlists')) || []; } catch (e) {}
    if (anonWls.length) {
      fetch('/apps/loved/claim', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lists: anonWls.map(function (w) { return { token: w.token, editKey: w.editKey }; }) })
      }).then(function (r) {
        if (r.ok) { try { localStorage.removeItem('nostalgia:wishlists'); } catch (e) {} }
      }).catch(function () {});
    }
  }).catch(function () {});
})();

/* ---- PDP gallery: the counter, and the phone carousel -----------------------
   Desktop gets a "1 / 10" pill in the corner of the photo (base.css styles
   it; it is hidden on phones). Phones get the carousel: snippets/product-
   gallery.liquid renders a .pdp-track of .pdp-slide images over the frame,
   base.css shows it below 760px, and this keeps it and #pdp-main in step.

   #pdp-main stays the single source of truth for which photo is showing. The
   variant picker, the lightbox and the desktop arrows all set its src, and the
   gallery snippet's observers key everything (alt, crop, warming) off it. So:
     scroll the track  -> when it settles on a slide, set main.src to match
     main.src changes  -> jump the track to that slide (instantly, never
                          smoothly: a smooth scroll passes through the slides
                          in between, each of which would set main.src back)
   The counter reads main.src too, so it stays right whoever changed the photo. */
(function () {
  "use strict";
  var gal = document.querySelector('.pdp-gallery');
  if (!gal) return;
  var im = gal.querySelector('.im');
  var main = gal.querySelector('#pdp-main');
  if (!im || !main) return;

  // image_url emits protocol-relative URLs; img.src reads back absolute
  function norm(s) { return String(s || '').replace(/^https?:/, ''); }
  function thumbSrcs() {
    return Array.prototype.filter.call(
      gal.querySelectorAll('.pdp-thumb[data-full]'),
      function (b) { return !b.hidden; }        // other layouts' runs sit hidden in the strip
    ).map(function (b) { return b.getAttribute('data-full'); });
  }
  var srcs = thumbSrcs();
  if (srcs.length < 2) return;
  function at() {
    var n = norm(main.getAttribute('src'));
    for (var i = 0; i < srcs.length; i++) { if (norm(srcs[i]) === n) return i; }
    return 0;
  }

  /* ---- the desktop counter ---- */
  var count = document.createElement('div');
  count.className = 'pdp-count';
  count.setAttribute('aria-hidden', 'true');
  im.appendChild(count);
  function paintCount() { count.textContent = (at() + 1) + ' / ' + srcs.length; }

  /* ---- the phone carousel ---- */
  var track = im.querySelector('.pdp-track');
  var slides = [], dots = null;
  // The frame colours slide has no <img>: its URL sits in data-src and is painted
  // as a background only once the shopper swipes - see
  // snippets/product-gallery-frames.liquid for why Google must never see it.
  function slideSrc(sl) { var i = sl.querySelector('img'); return i ? i.getAttribute('src') : (sl.getAttribute('data-src') || ''); }
  function paintBg() {
    if (!track) return;
    Array.prototype.forEach.call(track.querySelectorAll('.pdp-slide--bg[data-src]'), function (sl) {
      if (!sl.style.backgroundImage) sl.style.backgroundImage = 'url("' + sl.getAttribute('data-src') + '")';
    });
  }
  if (track) {
    track.addEventListener('scroll', paintBg, { once: true, passive: true });
    track.addEventListener('touchstart', paintBg, { once: true, passive: true });
  }
  /* ---- wrapping round ----
     A swipe past the last photo goes back to the first. A native track has
     no way to do that except by having somewhere to scroll to, so relist()
     puts a copy of the first slide after the last one (data-clone). Land on
     it and, once the snap has settled and the finger is up, the track jumps
     back to the real first slide - same picture, so nothing is seen to
     happen. The clone is not in `slides`: every index below is the LOGICAL
     one (0..n-1), and phys() is the only thing that knows the track is one
     slide longer than that. Backwards from the first photo stays put. */
  function relist() {
    if (track) {
      Array.prototype.forEach.call(track.querySelectorAll('.pdp-slide[data-clone]'), function (c) { c.parentNode.removeChild(c); });
    }
    slides = track ? Array.prototype.filter.call(track.querySelectorAll('.pdp-slide'), function (s) { return !s.hidden; }) : [];
    if (track && slides.length > 1) {
      var clone = slides[0].cloneNode(true);
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      var ci = clone.querySelector('img');
      if (ci) { ci.setAttribute('loading', 'lazy'); ci.removeAttribute('fetchpriority'); ci.alt = ''; }
      var lastVisible = slides[slides.length - 1];
      lastVisible.parentNode.insertBefore(clone, lastVisible.nextSibling);
    }
    if (!dots) return;
    dots.innerHTML = '';
    slides.forEach(function () { dots.appendChild(document.createElement('i')); });
    dots.hidden = slides.length < 2;
  }
  // the slide the track is physically on: 0..n, where n is the clone
  function phys() {
    var w = track.clientWidth;
    return w ? Math.max(0, Math.min(slides.length, Math.round(track.scrollLeft / w))) : 0;
  }
  function slideAt() { return slides.length ? phys() % slides.length : 0; }
  var touching = false, settle = null;
  // On the clone means at the far end of the track. Measured against the
  // track's own maximum rather than n * clientWidth: clientWidth is an
  // integer and the slides are not, so on a phone the two drift apart by a
  // few pixels over ten slides and an exact comparison never matched.
  function onClone() {
    if (slides.length < 2) return false;
    var max = track.scrollWidth - track.clientWidth;
    return max > 0 && track.scrollLeft > max - track.clientWidth * 0.5;
  }
  function wrap() { if (onClone()) track.scrollTo({ left: 0, behavior: 'auto' }); }
  function settled() {
    settle = null;
    if (touching) return;
    wrap();
  }
  function slideOf(src) {
    var n = norm(src);
    for (var i = 0; i < slides.length; i++) { if (norm(slideSrc(slides[i])) === n) return i; }
    return -1;
  }
  function paintDots(i) {
    if (!dots) return;
    Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === i); });
  }
  // main -> track. Instant on purpose; see the note above.
  function follow() {
    if (!track || !slides.length) return;
    var i = slideOf(main.getAttribute('src'));
    if (i < 0) return;
    // slideAt() is logical, so sitting on the clone counts as being on photo
    // one and this does not fight the settle that jumps it there for real
    if (slideAt() !== i) track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' });
    paintDots(i);
  }
  if (track) {
    dots = document.createElement('div');
    dots.className = 'pdp-dots';
    dots.setAttribute('aria-hidden', 'true');
    im.appendChild(dots);
    relist();
    // track -> main, once per frame: the settle fires a burst of scroll
    // events and only the index matters.
    var raf = null;
    track.addEventListener('scroll', function () {
      if (settle) clearTimeout(settle);
      settle = setTimeout(settled, 150);   // the snap has stopped: wrap if on the clone
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = slideAt();
        paintDots(i);
        var s = slides[i] ? slideSrc(slides[i]) : '';
        if (s && norm(main.getAttribute('src')) !== norm(s)) main.src = s;
      });
    }, { passive: true });
    // never jump the track while a finger is dragging it - but a finger that
    // has just landed on the clone is about to swipe from the end, so jump
    // to the first slide under it before it moves; the same picture is
    // there, and the swipe then has somewhere to go
    track.addEventListener('touchstart', function () { touching = true; wrap(); }, { passive: true });
    track.addEventListener('touchend', function () { touching = false; if (!settle) settle = setTimeout(settled, 150); }, { passive: true });
    track.addEventListener('touchcancel', function () { touching = false; }, { passive: true });
    // A native scroll never synthesises a click, so a click here is a tap on
    // the photo: open the lightbox where main-product wires one up. The slide
    // under the finger is asked directly rather than main.src, which can be a
    // frame behind while the snap is still settling.
    track.addEventListener('click', function () {
      if (!window.pdpZoom) return;
      var s = slides[slideAt()] ? slideSrc(slides[slideAt()]) : main.getAttribute('src');
      window.pdpZoom(s);
    });
    // Rotating the phone changes the slide width, and the scroll offset with it.
    window.addEventListener('resize', follow);
    follow();
  }

  // the Layout dropdown swaps the visible run; the counter, the dots and the
  // track follow it (the gallery snippet has already put main on the new
  // run's first photo by the time this runs - it registered first)
  document.addEventListener('pdp:layout', function () {
    srcs = thumbSrcs();
    relist();
    if (track) track.scrollTo({ left: 0, behavior: 'auto' });
    paintCount();
    follow();
  });

  if (window.MutationObserver) {
    new MutationObserver(function () { paintCount(); follow(); }).observe(main, { attributes: true, attributeFilter: ['src'] });
  }
  paintCount();
})();
